<div class="mat-calendar-controls">
    <button mat-icon-button type="button" [disabled]="isPreviousDisabled" (click)="setPreviousPeriod()">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-button type="button" class="mat-calendar-spacer header-label" (click)="currentPeriodClicked()">
        {{ periodLabel }}
        <mat-icon iconPositionEnd>{{ isMonthView ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon>
    </button>
    <button mat-icon-button type="button" [disabled]="isNextDisabled" (click)="setNextPeriod()">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div>
